export const BI_USERS_ENDPOINT = 'blog-app-users';
export const BI_USERS_SRC = '69';
//# sourceMappingURL=bi-users-events.js.map